import { EventV2 } from '@/services/EventService/abstract/EventV2';

export default class EditModeCloseEvent extends EventV2<object> {}
